export default {
	form: {
		title: 'Two-factor Authentication',
		description: 'กรุณากรอกรหัส OTP ที่ได้รับจาก <a href="https://staff-app.com7.in/it-easy/index.html" target="_blank" rel="noopener noreferrer">ITEasy</a> ของคุณ',
		input: {
			code: {
				placeholder: 'รหัส OTP 6 หลัก',
			},
		},
		button: {
			submit: 'ยืนยัน',
			resend: 'ส่งอีกครั้ง',
			back: 'ย้อนกลับ',
			loading: 'โปรดรอสักครู่',
			countdown: 'ส่งอีกครั้งใน {countdown}s',
		},
	},
};
